(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-scroll-to-top]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      // On desktop (>=990px) this theme makes `.page-wrapper` the actual
      // scrolling element (html/body are locked with overflow: hidden), so
      // window.scrollTo alone does nothing there. On mobile, window/the
      // document is the scrolling element instead. Scroll all of the
      // possible containers so this works at every breakpoint.
      var pageWrapper = document.querySelector('.page-wrapper');
      if (pageWrapper) {
        pageWrapper.scrollTo({ top: 0, behavior: 'smooth' });
      }
      document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
